
<script>
import { mapGetters } from 'vuex';
import { find } from 'lodash';
import { format } from 'date-fns';
import { parseISO } from 'date-fns/fp';
import { fr } from 'date-fns/locale';

export default {
  name: 'LibelleDatesLivraison',
  props: {
    dateDebut: {
      type: String,
      default: null
    },
    dateFin: {
      type: String,
      default: null
    },
    horaireDebut: {
      type: String,
      default: null
    },
    horaireFin: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({ ref: 'referentiel/referentiel' }),
    libelle () {
      let str = this.ref.libellesPeriodesLivraisons[this.horaireDebut + '-' + this.horaireFin];

      const dateDebutStr = this.dateDebut ? format(parseISO(this.dateDebut), 'EEEE dd/MM/yyyy', { locale: fr }) : '-';
      const dateFinStr = this.dateFin ? format(parseISO(this.dateFin), 'EEEE dd/MM/yyyy', { locale: fr }) : '-';

      if (str) {
        str = str.replace('<deb>', dateDebutStr);
        str = str.replace('<fin>', dateFinStr);
        str = str.replace('<liste-date>', `du ${dateDebutStr} au ${dateFinStr}`);
      } else {
        const libelleHoraireDebut = this.getLibeleHoraire(this.horaireDebut);
        const libelleHoraireFin = this.getLibeleHoraire(this.horaireFin);
        const debut = dateDebutStr + (this.horaireDebut !== 'ID' && libelleHoraireDebut ? ` (${libelleHoraireDebut})` : '');
        const fin = dateFinStr + (this.horaireFin !== 'ID' && libelleHoraireFin ? ` (${libelleHoraireFin})` : '');
        str = `du ${debut} au ${fin}`;
      }

      str = str.replace(/du (.+) au \1/, 'le $1');
      return ' Livraison ' + str;
    }
  },

  methods: {
    getLibeleHoraire (code) {
      try {
        return find(this.ref.periodesLivraison, { code }).libelle;
      } catch (e) {
        return '';
      }
    }
  }
};
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span>{{ libelle }}</span>
</template>

<style lang="scss" scoped>
// ::v-deep .line{
//   display: inline-block;
// }

::v-deep .line {
  display: inline-flex;
  flex-wrap: wrap;

  & > * {
    display: inline-block;
  }
}
</style>
